const where = [];

const orderBy = ["created_at_date"];

const moduleOrders = {
	firestorePath: "coaching_orders",
	firestoreRefType: "collection", // or 'doc'
	moduleName: "orders",
	statePropName: "data",
	namespaced: true, // automatically added
	sync: {
		where,
		orderBy
	},

	state: {},
	getters: {
		allOrdersByDateDesc: (state, getters) => {
			return Object.values(state.data).sort(function(a, b) {
				if (a.created_at_date.seconds < b.created_at_date.seconds) {
					return 1;
				}
				if (a.created_at_date.seconds > b.created_at_date.seconds) {
					return -1;
				}
				// a must be equal to b
				return 0;
			});
		}
	},
	mutations: {},
	actions: {}
};

export default moduleOrders;
